export const UPDATE_STUDENT_VALIDATION = 'UPDATE_STUDENT_VALIDATION';
export const updateStudentValidation = data => ({
  type: UPDATE_STUDENT_VALIDATION,
  payload: { key: data.key, value: data.value },
});
